import { EnvironmentProviders, Provider } from '@angular/core';
import { ListingPageService } from 'src/app/shared/components/listing-page/listing-page.service';
import { QueryParamsHandlerService } from 'src/app/shared/components/listing-page/services/query-params-handler/query-params-handler.service';
import { LISTING_MODEL } from 'src/app/shared/constants/tokens';
import { MissingProgrammingRecordsListingFiltersSourceService } from './missing-programming-records-listing-filters-source.service';
import { MissingProgrammingRecordsListingDataSourceService } from './missing-programming-records-listing-data-source.service';
import { MissingProgrammingRecordsListingExportConfigService } from './missing-programming-records-listing-export-config.service';
import { MissingProgrammingRecordsListingModelService } from './missing-programming-records-listing-model.service';

export const provideMissingProgrammingRecordsListing = (): (Provider | EnvironmentProviders)[] => [
  MissingProgrammingRecordsListingFiltersSourceService,
  MissingProgrammingRecordsListingDataSourceService,
  MissingProgrammingRecordsListingExportConfigService,
  { provide: LISTING_MODEL, useClass: MissingProgrammingRecordsListingModelService },
  ListingPageService,
  QueryParamsHandlerService
];
